'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onEdit", "onTokenRemove"];
import PropTypes from 'prop-types';
import { KeyTypes, PopoverBodyMode } from '../../constants/popover';
import DataTokenPopoverBodyEdit from './DataTokenPopoverBodyEdit';
import DataTokenPopoverBodyLite from './DataTokenPopoverBodyLite';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  onModeChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onTokenRemove: PropTypes.func.isRequired
};
function DataTokenPopoverBodyBranch(props) {
  const {
      mode,
      onModeChange,
      onEdit,
      onTokenRemove
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  const handleEdit = () => {
    onModeChange(PopoverBodyMode.EDIT);
  };
  const handleUpdate = (...args) => {
    handleClose();
    onEdit(...args);
  };
  const handleKeyDown = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      handleClose();
    }
  };
  return /*#__PURE__*/_jsx(View, {
    onKeyDown: handleKeyDown,
    tabIndex: "-1",
    children: mode === PopoverBodyMode.PREVIEW ? /*#__PURE__*/_jsx(DataTokenPopoverBodyLite, {
      onEdit: handleEdit,
      onRemove: onTokenRemove
    }) : /*#__PURE__*/_jsx(DataTokenPopoverBodyEdit, Object.assign({}, rest, {
      onInsert: handleUpdate,
      onClose: handleClose
    }))
  });
}
DataTokenPopoverBodyBranch.propTypes = propTypes;
DataTokenPopoverBodyBranch.displayName = 'DataTokenPopoverBodyBranch';
export default DataTokenPopoverBodyBranch;